var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.77,
    height: 17.438,
    viewBox: "0 0 13.77 17.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.567,15.073,61.581,3.83a.477.477,0,0,0-.471-.439H59.084a3.4,3.4,0,0,0-6.8,0H50.26a.474.474,0,0,0-.471.439L48.8,15.073c0,.014,0,.029,0,.043a2.464,2.464,0,0,0,2.582,2.321h8.605a2.464,2.464,0,0,0,2.582-2.321A.176.176,0,0,0,62.567,15.073ZM55.685.963a2.467,2.467,0,0,1,2.449,2.428h-4.9A2.467,2.467,0,0,1,55.685.963Zm4.3,15.512H51.382a1.522,1.522,0,0,1-1.632-1.337l.943-10.78h1.59V5.82a.475.475,0,1,0,.95,0V4.358h4.9V5.82a.475.475,0,1,0,.95,0V4.358h1.59l.946,10.78A1.524,1.524,0,0,1,59.988,16.475Z",
    transform: "translate(-48.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.64f8885a6e3fe61effde963f7544673f.svg";
export { ForwardRef as ReactComponent };